export const bookingConstants = {
    GETALLHOSPITALS_REQUEST: "HOSPITALS_LIST_REQUEST",
    GETALLHOSPITALS_SUCCESS: "HOSPITALS_LIST_SUCCESS",
    GETALLHOSPITALS_FAILURE: "HOSPITALS_LIST_FAILURE",

    GETALLREPS_REQUEST: "REPS_LIST_REQUEST",
    GETALLREPS_SUCCESS: "REPS_LIST_SUCCESS",
    GETALLREPS_FAILURE: "REPS_LIST_FAILURE",

    GETKITSETBYKIT_REQUEST: "KITSETBYKIT_LIST_REQUEST",
    GETKITSETBYKIT_SUCCESS: "KITSETBYKIT_LIST_SUCCESS",
    GETKITSETBYKIT_FAILURE: "KITSETBYKIT_LIST_FAILURE",

    BOOKINGADD_REQUEST: "BOOKING_ADD_REQUEST",
    BOOKINGADD_SUCCESS: "BOOKING_ADD_SUCCESS",
    BOOKINGADD_FAILURE: "BOOKING_ADD_FAILURE",

    BOOKINGEDIT_REQUEST: "BOOKING_EDIT_REQUEST",
    BOOKINGEDIT_SUCCESS: "BOOKING_EDIT_SUCCESS",
    BOOKINGEDIT_FAILURE: "BOOKING_EDIT_FAILURE",

    GETHOSPITALADDRESS_REQUEST: "BOOKING_GETHOSPITALADDRESS_REQUEST",
    GETHOSPITALADDRESS_SUCCESS: "BOOKING_GETHOSPITALADDRESS_SUCCESS",
    GETHOSPITALADDRESS_FAILURE: "BOOKING_GETHOSPITALADDRESS_FAILURE",

    BOOKINGUPDATE_REQUEST: "BOOKING_UPDATE_REQUEST",
    BOOKINGUPDATE_SUCCESS: "BOOKING_UPDATE_SUCCESS",
    BOOKINGUPDATE_FAILURE: "BOOKING_UPDATE_FAILURE",

    BOOKINGSTATUSUPDATE_REQUEST: "BOOKING_STATUSUPDATE_REQUEST",
    BOOKINGSTATUSUPDATE_SUCCESS: "BOOKING_STATUSUPDATE_SUCCESS",
    BOOKINGSTATUSUPDATE_FAILURE: "BOOKING_STATUSUPDATE_FAILURE",

    GETALLBOOKINGS_REQUEST: "BOOKINGS_GETALL_REQUEST",
    GETALLBOOKINGS_SUCCESS: "BOOKINGS_GETALL_SUCCESS",
    GETALLBOOKINGS_FAILURE: "BOOKINGS_GETALL_FAILURE",

    DELETE_REQUEST: "BOOKINGS_DELETE_REQUEST",
    DELETE_SUCCESS: "BOOKINGS_DELETE_SUCCESS",
    DELETE_FAILURE: "BOOKINGS_DELETE_FAILURE",
    
    SETRETURN_REQUEST: "SET_RETURN_REQUEST",
    SETRETURN_SUCCESS: "SET_RETURN_SUCCESS",
    SETRETURN_FAILURE: "SET_RETURN_FAILURE",

    BOOKINGCOUNT_REQUEST: "BOOKING_COUNT_REQUEST",
    BOOKINGCOUNT_SUCCESS: "BOOKING_COUNT_SUCCESS",
    BOOKINGCOUNT_FAILURE: "BOOKING_COUNT_FAILURE",

    BOOKINGDISPATCH_COUNT_REQUEST: "BOOKING_DISPATCH_COUNT_REQUEST",
    BOOKINGDISPATCH_COUNT_SUCCESS: "BOOKING_DISPATCH_COUNT_SUCCESS",
    BOOKINGDISPATCH_COUNT_FAILURE: "BOOKING_DISPATCH_COUNT_FAILURE",

    BOOKINGSAVEDISPATCH_REQUEST: "BOOKING_SAVEDISPATCH_REQUEST",
    BOOKINGSAVEDISPATCH_SUCCESS: "BOOKING_SAVEDISPATCH_SUCCESS",
    BOOKINGSAVEDISPATCH_FAILURE: "BOOKING_SAVEDISPATCH_FAILURE",

    BOOKINGLOG_REQUEST: "BOOKING_LOG_REQUEST",
    BOOKINGLOG_SUCCESS: "BOOKING_LOG_SUCCESS",
    BOOKINLOG_FAILURE: "BOOKING_LOG_FAILURE",

    BOOKINGSAVECOLLECTION_REQUEST: "BOOKING_SAVECOLLECTION_REQUEST",
    BOOKINGSAVECOLLECTION_SUCCESS: "BOOKING_SAVECOLLECTION_SUCCESS",
    BOOKINGSAVECOLLECTION_FAILURE: "BOOKING_SAVECOLLECTION_FAILURE",

    BOOKINGUPDATEDATE_REQUEST: "BOOKING_UPDATEDATE_REQUEST",
    BOOKINGUPDATEDATE_SUCCESS: "BOOKING_UPDATEDATE_SUCCESS",
    BOOKINGUPDATEDATE_FAILURE: "BOOKING_UPDATEDATEUPDATEDATE_FAILURE",

    BOOKINGREPSADMINUPDATE_REQUEST:"BOOKINGREPSADMINUPDATE_REQUEST",
    BOOKINGREPSADMINUPDATE_SUCCESS:"BOOKINGREPSADMINUPDATE_SUCCESS",
    BOOKINGREPSADMINUPDATE_FAILURE:"BOOKINGREPSADMINUPDATE_FAILURE"
};
